<template>
  <div class='package_sizes_list'>
    <template v-for='size in sizeList'>
      <Tooltip
        :content="getTooltipContent(size)"
        position='top'
        :show="shouldShowTooltip(size)"
      >
        <div class='package_size' :class="{ 'active': size.tallaId === sizeSelectedId, 'disabled': size.isDisabled }" @click='handleClick(size)'>

          <div v-if="size.estado && size.codigo !== 'P'" class='package_size--content'>

            <!-- Icon resolved by code with a fallback, so new DB sizes are never iconless -->
            <Icon :name="getSizeIcon(size.codigo)" :size="getSizeIconSize(size.codigo)" />

            <!-- Description -->
            <div v-if="size.codigo !== 'SBR'">
              <div class='text-xs-bold'>{{ size.alto }} x {{ size.ancho }} x {{ size.profundidad }} cm</div>
              <div class='text-xs-bold'>hasta {{ size.pesoMaximo }} kg</div>
              <div class='text-s-light'>{{ size.descripcion }}</div>
            </div>
            <div v-if="size.codigo === 'SBR'">
              <div class='text-xs-bold'>Documentos A4</div>
              <div class='text-s-light'>{{ size.descripcion }}</div>
            </div>

            <div v-if="size.isDisabled && size.disabledReason" class='text-s-light disabled_reason'>{{ size.disabledReason }}</div>

          </div>

          <div v-if="size.estado && size.codigo === 'P'" class='package_size--content'>
            <Icon name='Delivery-Box' variant='bulk' :size='32' />
            <div>
              <div class='text-xs-bold'>Hazlo único: suelta las cifras. 🛠️</div>
              <div class='text-s-light'>Personalizado</div>
            </div>
          </div>

        </div>
      </Tooltip>
    </template>
  </div>
</template>

<script>
import Icon from '@/components/Icon.vue'
import Tooltip from "@/components/Shared/Tooltip.vue";

export default {
  components: {
    Icon, Tooltip
  },
  props: {
    sizeSelectedId: { required: true },
    sizeList: { required: true, default: [] },
  },
  methods: {
    getSizeIcon(codigo) {
      const iconsByCode = {
        SBR: 'Document',
        XXS: 'Delivery-Box',
        XS: 'Delivery-Box',
        S: 'Delivery-Box-1',
        M: 'Delivery-Box-1',
        L: 'Delivery-Box-2',
        XL: 'Delivery-Box-2',
        XXL: 'Delivery-Box-2',
      }
      // Fallback for sizes added in the DB without an icon mapped here.
      return iconsByCode[codigo] || 'Delivery-Box-1'
    },
    getSizeIconSize(codigo) {
      return ['L', 'XL', 'XXL'].includes(codigo) ? 36 : 32
    },
    formatThousands(a, b, c) {
      const result = Number(a) * Number(b) * Number(c)
      return result.toLocaleString('en-US', { maximumFractionDigits: 0 })
    },
    getTooltipContent(size) {
      if (size.isDisabled && size.disabledReason) return size.disabledReason
      return `o hasta ${this.formatThousands(size.alto, size.ancho, size.profundidad)} cm²`
    },
    shouldShowTooltip(size) {
      if (size.isDisabled && size.disabledReason) return true
      // Every size that shows dimensions gets the volume tooltip, including new DB sizes.
      return !['P', 'SBR'].includes(size.codigo)
    },
    handleClick(size) {
      if (size.isDisabled) return
      this.$emit('input', size.tallaId)
      this.$emit('onSizeSelected', size)
    }
  },
}
</script>

<style lang='scss' scoped>
.package_sizes_list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 16px;

  .package_size {
    cursor: pointer;

    padding: 24px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    box-shadow: 0 0 0 1px #D0D0D0;
    border-radius: 12px;

    transition: .2s;

    &:not(.active):hover {
      background-color: #D0D0D0;
      box-shadow: 0 0 0 1px #D0D0D0;
    }

    &.disabled {
      cursor: not-allowed;
      opacity: .5;
      background: #F6F6F6;

      &:hover {
        background: #F6F6F6;
        box-shadow: 0 0 0 1px #D0D0D0;
      }
    }

    &.active {
      box-shadow: 0 0 0 1.5px #121212;
    }

    &--content {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 0 10px;
      gap: 5px;

      .disabled_reason {
        color: #B20000;
      }
    }
  }
}
</style>
